<template>
  <div class="mt-4 date-request-form-private-date">
    <label class="form-label" for="privateRequestDate">{{
      t('product.show.checkout.selectDate')
    }}</label>
    <div class="mt-1 relative w-full sm:hidden">
      <div class="relative w-full">
        <input
          id="privateRequestDate"
          v-model="date"
          :readonly="isMobile"
          :min="minDateFormatted"
          data-test-id="date-request-date-picker-1"
          step="1800"
          :placeholder="t('product.show.checkout.selectDate')"
          type="datetime-local"
          class="w-full border border-gray-200 rounded-lg p-2 bg-white mt-1"
          name="privateRequestDate"
          @input="(event) => emit('native-input', event)"
        />
      </div>
    </div>
    <div class="mt-1 relative w-full hidden sm:block">
      <Datepicker
        v-model="date"
        model-type="yyyy-MM-dd'T'HH:mm"
        time-picker-inline
        :format-locale="deLocale"
        format="dd.MM.yyyy, HH:mm"
        locale="de"
        :select-text="t('dateRequest.instantBooking.datePickerSelect')"
        text-input
        minutes-increment="30"
        :start-time="startTime"
        :placeholder="t('product.show.checkout.selectDate')"
        @open="emit('clear-errors', 'dates')"
      />
    </div>
    <span class="block mb-2 text-xs text-gray-400">
      {{ t('subscribeToEventUpdatesModal.firstStep.form.date1.helperText') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { de as deLocale } from 'date-fns/locale'

interface Props {
  minDateFormatted: string
  startTime: { hours: number; minutes: number }
}

const { minDateFormatted, startTime } = defineProps<Props>()

const date = defineModel<string | undefined>('date', { required: true })

const emit = defineEmits<{
  (e: 'native-input', event: Event): void
  (e: 'clear-errors', field: string): void
}>()

const { t } = useI18n()
const { isMobile } = useDevice()
</script>

<style lang="postcss" scoped>
.dp__menu {
  font-family: 'Lexend';
}
:deep(.dp__input) {
  @apply rounded-lg;
}
</style>
